import {analytics} from './firebaseConfig';
import {logEvent} from 'firebase/analytics';
import {events} from 'constants/firebase';

// Utility funtion for logging events to firebase console
export function logFirebaseEvent(
  eventName: string,
  eventPayload?: Record<string, string> | {},
) {
  logEvent(analytics, eventName, eventPayload);
}

/**
 * Events to be considered for analytics,
 *
 * - landing page reached
 *    - when the user open the landing page, an analytic event must be logged to the firebase console
 * - signed up for product (pre booking)
 *    - when the user submits the email for pre booking, then the event must be logged for the same,
 * - FAQ analytics
 *    - when the user submits the form for FAQ, then the event must be logged for the same.
 */

export function logPreBookingEvent(email: string) {
  // spliting email host and domain and passing it as serialized json to prevent
  // firebase from censoring the email in console
  const [h, d] = email.split('@');
  logFirebaseEvent(events.preBookingEvent, {
    email,
    userData: JSON.stringify({h, d}),
  });
}

export function logFAQEvent(email: string, question: string) {
  // spliting email host and domain and passing it as serialized json to prevent
  // firebase from censoring the email in console
  const [h, d] = email.split('@');
  logFirebaseEvent(events.faqEvent, {
    email,
    question,
    userData: JSON.stringify({h, d, q: question}),
  });
}

export function logLandingPageVisitEvent() {
  logFirebaseEvent(events.landingPageLoad);
}
